/**
 * IM底部
 * author: jiaheming
 * date: 2019/06/12
 */
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getCustomerServer } from '../../actions/actions';
import config from '../../config';
import xiaosong from '../../static/images/xiaosong_m.png';
import xiaoxi from '../../static/images/xiaoxi_m.png';

const Footer_style = styled.div`
    display: flex;
    flex: none;
    width: 100%;
    height: 84px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -2px 4px 0px rgba(171, 171, 171, 0.24);
    position: absolute;
    bottom: 0;
    left: 0;
`;
const Image_style = styled.div`
    position: relative;
    width: 80px;
    margin: 0 0 0 63px;

    & > img {
        width: 44px;
        height: 44px;
        background: rgba(255, 255, 255, 1);
        margin: 20px auto;
        display: block;
        transition: all 0.5s;
        border-radius: 50%;
        box-shadow: 0 4px 13px 0 rgba(167, 192, 208, 0.5);
    }
`;

const Info_style = styled.div`
    margin: 16px 50px 0 0;
    display: flex;

    .im-footer-info {
        flex: 1 1 auto;

        .im-footer-up {
            margin: 8px 0 0 0;

            & > span {
                height: 22px;
                font-size: 14px;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                line-height: 22px;
                margin: 0 0 5px 0;
            }
        }

        .im-footer-down {
            width: 134px;
            height: 13px;
            font-size: 13px;
            font-weight: 400;
            color: rgba(103, 189, 122, 1);
            line-height: 13px;
        }
    }

    & > a {
        flex: none;
        display: inline-block;

        img {
            height: 18px;
            width: 18px;
            margin: 28px 0 0 0;
        }
    }
`;

class IMFooter extends React.Component {
    render() {
        let { showChat } = this.props;
        return (
            <Footer_style>
                <Image_style className={showChat ? 'im-footer-show' : ''}>
                    <img src={xiaosong} alt="xiaosong" />
                </Image_style>
                <Info_style>
                    <div className="im-footer-info">
                        <div className="im-footer-up">
                            <span>无讼客服</span>
                        </div>
                        <div className="im-footer-down">小讼期待为您服务哦~</div>
                    </div>
                    <a
                        href="javascript:;"
                        onClick={() => {
                            this.props.getCustomerServer();
                        }}
                    >
                        <img src={xiaoxi} alt="xiaoxi" />
                    </a>
                </Info_style>
            </Footer_style>
        );
    }
}

function mapStateToProps(store) {
    const { showChat } = store[config.reduxStoreName];
    return {
        showChat,
    };
}

export default connect(mapStateToProps, { getCustomerServer })(IMFooter);
